import API from "../index";

export const getCms = async (type) => {
    return API.get(`/cms/${type}`);
};

export const updateCms = async (payload) => {
    return API.post(`/cms/update`, payload, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const getFaqsService = async () => {
    return API.get(`/faq/list`);
};

export const updateFaqs = async (payload) => {
    return API.put(`/faq/update/${payload.id}`, payload);
};

export const deleteFaqs = async (id) => {
    return API.delete(`/faq/delete/${id}`);
}

export const createFaqs = async (payload) => {
    return API.post(`/faq/create`, payload);
}

export const getFooterCmsService = async () => {
    return API.get("/cms/list/footer")
}

export const upsertFooterCms = async (payload) => {
    return API.post(`/cms/update/footer`, payload, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export const getContactUsListService = async (payload) => {
    return API.get("/contact/list", {
        params: payload
    })
}

export const deleteContactUs = async (id) => {
    return API.delete(`/contact/delete/${id}`);
}